import { render } from "./ScreenAdapter.vue?vue&type=template&id=53b996f8&scoped=true"
import script from "./ScreenAdapter.vue?vue&type=script&lang=js"
export * from "./ScreenAdapter.vue?vue&type=script&lang=js"

import "./ScreenAdapter.vue?vue&type=style&index=0&id=53b996f8&lang=scss&scoped=true"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53b996f8"]])

export default __exports__